import { Material } from '@cutr/constants/cutlist.ts';

export type BeamSize = { thicknessMM: number; widthsMM: number[] };

export const getBeamSizes = (materials: Material[]): BeamSize[] => {
  const widthsByThickness = new Map<number, Set<number>>();
  for (const { thicknessUM, widthMM } of materials) {
    const thicknessMM = thicknessUM / 1000;
    if (!widthsByThickness.has(thicknessMM)) {
      widthsByThickness.set(thicknessMM, new Set());
    }
    widthsByThickness.get(thicknessMM)?.add(widthMM);
  }

  return [...widthsByThickness]
    .sort(([a], [b]) => a - b)
    .map(([thicknessMM, widths]) => ({
      thicknessMM,
      widthsMM: [...widths].sort((a, b) => a - b),
    }));
};
